import type {ReactElement} from 'react';
import React from 'react';
import {motion} from 'framer-motion';
import type {AiPromptBoxProTipProps} from './ai-prompt-box-pro-tip.types';
import styles from './ai-prompt-box-pro-tip.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';

const ANIMATION_ENTER_DURATION_S = 0.3;
const ANIMATION_EXIT_DURATION_S = 0.6;

export function AiPromptBoxProTip({type, icon, message, onDismiss}: AiPromptBoxProTipProps): ReactElement {
  return (
    <motion.div
      className={styles.proTipContainer}
      data-tip-type={type}
      initial={{y: '100%', opacity: 0}}
      animate={{y: 0, opacity: 1, transition: {duration: ANIMATION_ENTER_DURATION_S, ease: 'easeInOut'}}}
      exit={{y: '100%', opacity: 0, transition: {duration: ANIMATION_EXIT_DURATION_S, ease: 'easeInOut'}}}
    >
      <div className={styles.contentRow}>
        <div className={styles.tipContent}>
          <Icon
            icon={icon}
            size={IconSize.SIZE_ICON_16}
            type={IconType.FLAT}
            className={styles.tipIcon}
          />
          <span className={styles.tipText}>
            {message}
          </span>
        </div>
        <Icon
          icon="icon-close"
          size={IconSize.SIZE_ICON_16}
          type={IconType.GHOST_UNCOLORED}
          onClick={onDismiss}
          className={styles.closeButton}
          isUsedAsButton
          ariaLabel="Dismiss tip"
        />
      </div>
    </motion.div>
  );
}
